var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSinfin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1216",
    "data-name": "Group 1216",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29.109,
    height: 32.46,
    viewBox: "0 0 29.109 32.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fafafa;\r\n      }\r\n\r\n      .cls-2 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_733",
    "data-name": "Rectangle 733",
    className: "cls-1",
    width: 29.109,
    height: 32.46
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1215",
    "data-name": "Group 1215",
    className: "cls-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1220",
    "data-name": "Path 1220",
    className: "cls-1",
    d: "M14.614,35.054a.442.442,0,0,1-.18-.038L.762,28.93a.442.442,0,0,1,0-.806l13.672-6.086a.446.446,0,0,1,.359,0l13.673,6.086a.441.441,0,0,1,0,.806L14.793,35.016a.435.435,0,0,1-.179.038M2.026,28.527l12.588,5.6,12.588-5.6-12.588-5.6Z",
    transform: "translate(-0.059 -2.594)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1221",
    "data-name": "Path 1221",
    className: "cls-1",
    d: "M30.555,26.374a.453.453,0,0,1-.179-.038L16.262,20.073a.442.442,0,0,1-.262-.4V.44a.439.439,0,0,1,.2-.37A.445.445,0,0,1,16.62.037L30.734,6.3A.441.441,0,0,1,31,6.7v19.23a.442.442,0,0,1-.441.441M16.882,19.383l13.232,5.871V6.99L16.882,1.118Z",
    transform: "translate(-1.886 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1222",
    "data-name": "Path 1222",
    className: "cls-1",
    d: "M.441,26.374A.443.443,0,0,1,.2,26.3a.439.439,0,0,1-.2-.37V6.7a.442.442,0,0,1,.262-.4L14.376.037a.442.442,0,0,1,.62.4V19.67a.442.442,0,0,1-.262.4L.62,26.336a.453.453,0,0,1-.179.038M.882,6.99V25.254l13.231-5.871V1.118Z",
    transform: "translate(0 0)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSinfin);
export default __webpack_public_path__ + "static/media/Icon_sinfin.899ccf6091d3cbb9a538d325d5d08056.svg";
export { ForwardRef as ReactComponent };